import { Box, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { CustomHeading } from 'shared-components';
import { ApplicationState } from '../../../../../store';
import Field from '../../../../Field/Field';
import { PrevNextButtons } from '../../../../PrevNextButtons';

import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { getApplicationData } from '@/components/pages/applicant-dashboard/sections/helpers/getApplicationData';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';

export default function InformationProcessing() {
  const navigate = useNavigate();
  const { application } = useSelector((state: ApplicationState) => state.apply);
  const { applyConfig } = useSelector((state: ApplicationState) => state.applyConfig);
  const { nextRoute, previousRoute } = useTaskNavigation();

  const { initial, current } = getApplicationData(application);
  const { informationProcessingConsent } = current;
  const { informationProcessingConsent: initialInformationProcessingConsent } = initial;

  const AcceptanceText = () => (
    <>
      <Text>
        I understand that the application process will require the collection of personal and sensitive information that
        belongs to me.
      </Text>
      <Text>
        This data will be processed by the university and approved representatives for the purpose of my application and
        admission.
      </Text>
    </>
  );

  const RejectionText = () => <Text>This user has not accepted their information processing consent.</Text>;

  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <CustomHeading level="h1" flexGrow={1} mb={8}>
          Information processing
        </CustomHeading>

        <CustomHeading level="h2" mb={2} mt={6} fontSize="md">
          Data
        </CustomHeading>

        <Box>
          {(informationProcessingConsent || initialInformationProcessingConsent) && (
            <Field
              leftLabel="Agreed to"
              value={informationProcessingConsent ? <AcceptanceText /> : <RejectionText />}
              originalValue={initialInformationProcessingConsent ? <AcceptanceText /> : <RejectionText />}
            />
          )}
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={() => {
              // Use dynamic navigation, but fallback to legacy logic if needed
              if (previousRoute) {
                navigate(previousRoute);
              } else {
                // Fallback to legacy logic for declarations task
                const previousSection = applyConfig?.disableDeclarationTask ? '../referral' : '../declarations';
                navigate(previousSection);
              }
            }}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
